import {Province} from '../province';
import {Dropdown} from './dropdown';

const PROVINCE_POSSIBILITY_FR: Dropdown<Province>[] = [
  {value: Province.AB, name: 'Alberta'},
  {value: Province.BC, name: 'Colombie-Britannique'},
  {value: Province.MB, name: 'Manitoba'},
  {value: Province.NB, name: 'Nouveau-Brunswick'},
  {value: Province.NL, name: 'Terre-Neuve-et-Labrador'},
  {value: Province.NT, name: 'Territoires du Nord-Ouest'},
  {value: Province.NS, name: 'Nouvelle-Écosse'},
  {value: Province.NU, name: 'Nunavut'},
  {value: Province.ON, name: 'Ontario'},
  {value: Province.PE, name: 'Île-du-Prince-Édouard'},
  {value: Province.QC, name: 'Québec'},
  {value: Province.SK, name: 'Saskatchewan'},
  {value: Province.YT, name: 'Yukon'},
];

const PROVINCE_POSSIBILITY_EN: Dropdown<Province>[] = [
  {value: Province.AB, name: 'Alberta'},
  {value: Province.BC, name: 'British-Colombia'},
  {value: Province.MB, name: 'Manitoba'},
  {value: Province.NB, name: 'New-Brunswick'},
  {value: Province.NL, name: 'Newfoundland and Labrador'},
  {value: Province.NT, name: 'Northwest territories'},
  {value: Province.NS, name: 'Nova Scotia'},
  {value: Province.NU, name: 'Nunavut'},
  {value: Province.ON, name: 'Ontario'},
  {value: Province.PE, name: 'Prince Edward Island'},
  {value: Province.QC, name: 'Quebec'},
  {value: Province.SK, name: 'Saskatchewan'},
  {value: Province.YT, name: 'Yukon'},
];

const SUPPORTED_PROVINCE_POSSIBILITY_FR: Dropdown<Province>[] = [
  {value: Province.AB, name: 'Alberta'},
  {value: Province.MB, name: 'Manitoba'},
  {value: Province.NB, name: 'Nouveau-Brunswick'},
  {value: Province.ON, name: 'Ontario'},
  {value: Province.PE, name: 'Île-du-Prince-Édouard'},
  {value: Province.QC, name: 'Québec'},
];

const SUPPORTED_PROVINCE_POSSIBILITY_EN: Dropdown<Province>[] = [
  {value: Province.AB, name: 'Alberta'},
  {value: Province.MB, name: 'Manitoba'},
  {value: Province.NB, name: 'New-Brunswick'},
  {value: Province.ON, name: 'Ontario'},
  {value: Province.PE, name: 'Prince Edward Island'},
  {value: Province.QC, name: 'Quebec'},
];

export const PROVINCE_POSSIBILITY = {
  en: PROVINCE_POSSIBILITY_EN,
  fr: PROVINCE_POSSIBILITY_FR,
};

export const SUPPORTED_PROVINCE_POSSIBILITY = {
  en: SUPPORTED_PROVINCE_POSSIBILITY_EN,
  fr: SUPPORTED_PROVINCE_POSSIBILITY_FR,
};
